import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';


export function SitemarkIcon() {
  return (
    <SvgIcon sx={{ height: 21, width: 100 }}>
      <svg
        width={86}
        height={19}
        viewBox="0 0 86 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#B4C0D3"
          d="m.787 12.567 6.055-2.675 3.485 2.006.704 6.583-4.295-.035.634-4.577-.74-.422-3.625 2.817-2.218-3.697Z"
        />
        <path
          fill="#00D3AB"
          d="m10.714 11.616 5.352 3.908 2.112-3.767-4.295-1.725v-.845l4.295-1.76-2.112-3.732-5.352 3.908v4.013Z"
        />
        <path
          fill="#4876EF"
          d="m10.327 7.286.704-6.583-4.295.07.634 4.577-.74.422-3.66-2.816L.786 6.617l6.055 2.676 3.485-2.007Z"
        />
        <path
          fill="#4876EE"
          d="M32.507 8.804v6.167h2.312v-7.86h-3.366v1.693h1.054ZM32.435 6.006c.212.22.535.33.968.33.434 0 .751-.11.953-.33.213-.23.318-.516.318-.86 0-.354-.105-.641-.318-.86-.202-.23-.52-.345-.953-.345-.433 0-.756.115-.968.344-.202.22-.303.507-.303.86 0 .345.101.632.303.861ZM24.46 14.799c.655.296 1.46.444 2.413.444.896 0 1.667-.139 2.312-.416.645-.277 1.141-.664 1.488-1.162.357-.506.535-1.094.535-1.764 0-.65-.169-1.2-.506-1.649-.328-.459-.785-.818-1.373-1.076-.587-.267-1.266-.435-2.037-.502l-.809-.071c-.481-.039-.828-.168-1.04-.388a1.08 1.08 0 0 1-.318-.774c0-.23.058-.44.173-.631.116-.201.29-.359.52-.474.241-.114.535-.172.882-.172.366 0 .67.067.91.201.053.029.104.059.15.09l.012.009.052.037c.146.111.263.243.35.395.125.21.188.444.188.703h2.311c0-.689-.159-1.286-.476-1.793-.318-.516-.776-.913-1.373-1.19-.588-.287-1.296-.43-2.124-.43-.79 0-1.474.133-2.052.4a3.131 3.131 0 0 0-1.358 1.12c-.318.487-.477 1.066-.477 1.735 0 .927.314 1.673.94 2.237.626.564 1.464.89 2.514.976l.794.071c.645.058 1.113.187 1.401.388a.899.899 0 0 1 .434.788 1.181 1.181 0 0 1-.231.717c-.154.201-.38.36-.68.474-.298.115-.669.172-1.112.172-.49 0-.89-.067-1.199-.2-.308-.144-.539-.33-.694-.56a1.375 1.375 0 0 1-.216-.746h-2.297c0 .679.168 1.281.505 1.807.337.517.834.928 1.489 1.234ZM39.977 15.07c-.8 0-1.445-.095-1.936-.286a2.03 2.03 0 0 1-1.084-.99c-.221-.469-.332-1.1-.332-1.893V8.789h-1.2V7.11h1.2V4.988h2.153V7.11h2.312V8.79h-2.312v3.198c0 .373.096.66.289.86.202.192.486.287.852.287h1.17v1.937h-1.112Z"
        />
        <path
          fill="#4876EE"
          fillRule="evenodd"
          d="M43.873 14.899c.52.23 1.117.344 1.791.344.665 0 1.252-.115 1.763-.344.51-.23.934-.55 1.271-.96.337-.412.564-.88.679-1.407h-2.124c-.096.24-.279.44-.549.603-.27.162-.616.244-1.04.244-.262 0-.497-.031-.704-.093a1.572 1.572 0 0 1-.423-.194 1.662 1.662 0 0 1-.636-.803 3.159 3.159 0 0 1-.163-.645h5.784v-.775a4.28 4.28 0 0 0-.463-1.98 3.686 3.686 0 0 0-1.343-1.477c-.578-.382-1.291-.574-2.139-.574-.645 0-1.223.115-1.733.345-.501.22-.92.52-1.257.903a4.178 4.178 0 0 0-.78 1.305c-.174.478-.26.98-.26 1.506v.287c0 .507.086 1.004.26 1.492.183.478.443.913.78 1.305.347.382.775.688 1.286.918Zm-.094-4.674.02-.09a2.507 2.507 0 0 1 .117-.356c.145-.354.356-.622.636-.804.104-.067.217-.123.339-.165.204-.071.433-.107.686-.107.395 0 .723.09.983.272.27.173.472.426.607.76a2.487 2.487 0 0 1 .16.603h-3.57c.006-.038.013-.076.022-.113Z"
          clipRule="evenodd"
        />
        <path
          fill="#4876EE"
          d="M50.476 14.97V7.112h1.835v1.98a4.54 4.54 0 0 1 .173-.603c.202-.536.506-.937.91-1.205.405-.277.9-.416 1.488-.416h.101c.598 0 1.094.139 1.489.416.404.268.707.67.91 1.205l.016.04.013.037.028-.077c.212-.536.52-.937.925-1.205.405-.277.901-.416 1.489-.416h.1c.598 0 1.098.139 1.503.416.414.268.727.67.94 1.205.211.535.317 1.205.317 2.008v4.475h-2.312v-4.604c0-.43-.115-.78-.346-1.047-.222-.268-.54-.402-.954-.402-.414 0-.742.139-.982.416-.241.268-.362.626-.362 1.076v4.56h-2.326v-4.603c0-.43-.115-.78-.346-1.047-.222-.268-.535-.402-.94-.402-.423 0-.756.139-.996.416-.241.268-.362.626-.362 1.076v4.56h-2.311Z"
        />
        <path
          fill="#4876EE"
          fillRule="evenodd"
          d="M68.888 13.456v1.515h1.834v-4.82c0-.726-.144-1.319-.433-1.778-.289-.468-.712-.817-1.271-1.047-.549-.23-1.228-.344-2.037-.344a27.76 27.76 0 0 0-.896.014c-.318.01-.626.024-.924.043l-.229.016a36.79 36.79 0 0 0-.552.042v1.936a81.998 81.998 0 0 1 1.733-.09 37.806 37.806 0 0 1 1.171-.025c.424 0 .732.1.925.301.193.201.289.502.289.904v.029h-1.43c-.704 0-1.325.09-1.864.272-.54.172-.959.445-1.257.818-.299.363-.448.832-.448 1.405 0 .526.12.98.361 1.363.24.373.573.66.997.86.433.201.934.302 1.502.302.55 0 1.012-.1 1.388-.302.385-.2.683-.487.895-.86a2.443 2.443 0 0 0 .228-.498l.018-.056Zm-.39-1.397v-.63h-1.445c-.405 0-.718.1-.939.3-.212.192-.318.455-.318.79 0 .157.026.3.08.429a.99.99 0 0 0 .238.345c.221.191.534.287.939.287a2.125 2.125 0 0 0 .394-.038c.106-.021.206-.052.3-.092.212-.095.385-.253.52-.473.135-.22.212-.526.23-.918Z"
          clipRule="evenodd"
        />
        <path
          fill="#4876EE"
          d="M72.106 14.97V7.11h1.835v2.595c.088-.74.31-1.338.665-1.791.481-.603 1.174-.904 2.08-.904h.303v1.98h-.578c-.635 0-1.127.172-1.473.516-.347.334-.52.822-.52 1.463v4.001h-2.312ZM79.92 11.298h.767l2.499 3.672h2.6l-3.169-4.51 2.606-3.35h-2.427l-2.875 3.737V4.5h-2.312v10.47h2.312v-3.672Z"
        />
      </svg>
    </SvgIcon>
  );
}

export function FacebookIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.68 15.92C2.88 15.24 0 11.96 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 11.96 13.12 15.24 9.32 15.92L8.88 15.56H7.12L6.68 15.92Z"
          fill="url(#paint0_linear_795_116)"
        />
        <path
          d="M11.12 10.2391L11.48 7.99914H9.36V6.43914C9.36 5.79914 9.6 5.31914 10.56 5.31914H11.6V3.27914C11.04 3.19914 10.4 3.11914 9.84 3.11914C8 3.11914 6.72 4.23914 6.72 6.23914V7.99914H4.72V10.2391H6.72V15.8791C7.16 15.9591 7.6 15.9991 8.04 15.9991C8.48 15.9991 8.92 15.9591 9.36 15.8791V10.2391H11.12Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_795_116"
            x1="8"
            y1="0"
            x2="8"
            y2="15.9991"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1AAFFF" />
            <stop offset="1" stopColor="#0163E0" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function GoogleIcon() {
  return (
    <SvgIcon>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.68 8.18182C15.68 7.61455 15.6291 7.06909 15.5345 6.54545H8V9.64364H12.3055C12.1164 10.64 11.5491 11.4836 10.6982 12.0509V14.0655H13.2945C14.8073 12.6691 15.68 10.6182 15.68 8.18182Z"
          fill="#4285F4"
        />
        <path
          d="M8 16C10.16 16 11.9709 15.2873 13.2945 14.0655L10.6982 12.0509C9.98545 12.5309 9.07636 12.8218 8 12.8218C5.92 12.8218 4.15273 11.4182 3.52 9.52727H0.858182V11.5927C2.17455 14.2036 4.87273 16 8 16Z"
          fill="#34A853"
        />
        <path
          d="M3.52 9.52C3.36 9.04 3.26545 8.53091 3.26545 8C3.26545 7.46909 3.36 6.96 3.52 6.48V4.41455H0.858182C0.312727 5.49091 0 6.70545 0 8C0 9.29455 0.312727 10.5091 0.858182 11.5855L2.93091 9.97091L3.52 9.52Z"
          fill="#FBBC05"
        />
        <path
          d="M8 3.18545C9.17818 3.18545 10.2255 3.59273 11.0618 4.37818L13.3527 2.08727C11.9636 0.792727 10.16 0 8 0C4.87273 0 2.17455 1.79636 0.858182 4.41455L3.52 6.48C4.15273 4.58909 5.92 3.18545 8 3.18545Z"
          fill="#EA4335"
        />
      </svg>
    </SvgIcon>
  );
}

export function Rank1(props) {
  return (
    <SvgIcon {...props}>
      <svg width="110" height="262" viewBox="0 0 110 262" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="16" width="110" height="246" fill="url(#paint0_linear_302_2449)" />
        <path d="M16 0H94L110 16H0L16 0Z" fill="#D4AF37" />
        <path d="M62.9707 48.5156V120H53.9375V59.7949L35.7246 66.4355V58.2812L61.5547 48.5156H62.9707Z" fill="white" />
        <defs>
          <linearGradient id="paint0_linear_302_2449" x1="55" y1="16" x2="55" y2="189" gradientUnits="userSpaceOnUse">
            <stop stopColor="#dba35b" />
            <stop offset="1" stopColor="#f2d9be" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function Rank2(props) {
  return (
    <SvgIcon {...props}>
      <svg width="104" height="180" viewBox="0 0 104 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="16" width="104" height="164" fill="#C0C0C0" />
        <path d="M14.1818 0H104V16H0L14.1818 0Z" fill="#A8A8A8" />
        <path d="M71.9922 93.0625V99H34.7656V93.8047L53.3984 73.0625C55.6901 70.5104 57.4609 68.349 58.7109 66.5781C59.987 64.7812 60.8724 63.1797 61.3672 61.7734C61.888 60.3411 62.1484 58.8828 62.1484 57.3984C62.1484 55.5234 61.7578 53.8307 60.9766 52.3203C60.2214 50.7839 59.1016 49.5599 57.6172 48.6484C56.1328 47.737 54.3359 47.2812 52.2266 47.2812C49.7005 47.2812 47.5911 47.776 45.8984 48.7656C44.2318 49.7292 42.9818 51.0833 42.1484 52.8281C41.3151 54.5729 40.8984 56.5781 40.8984 58.8438H33.6719C33.6719 55.6406 34.375 52.7109 35.7812 50.0547C37.1875 47.3984 39.2708 45.2891 42.0312 43.7266C44.7917 42.138 48.1901 41.3438 52.2266 41.3438C55.8203 41.3438 58.8932 41.9818 61.4453 43.2578C63.9974 44.5078 65.9505 46.2786 67.3047 48.5703C68.6849 50.8359 69.375 53.4922 69.375 56.5391C69.375 58.2057 69.0885 59.8984 68.5156 61.6172C67.9688 63.3099 67.2005 65.0026 66.2109 66.6953C65.2474 68.388 64.1146 70.0547 62.8125 71.6953C61.5365 73.3359 60.1693 74.9505 58.7109 76.5391L43.4766 93.0625H71.9922Z" fill="white" />
      </svg>
    </SvgIcon>
  );
}

export function Rank3(props) {
  return (
    <SvgIcon {...props}>
      <svg width="104" height="180" viewBox="0 0 104 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="16" width="104" height="164" fill="#CD7F32" />
        <path d="M0 0H88.8727L104 16H0L0 0Z" fill="#B26A2C" />
        <path d="M45.9043 54.2441H50.2695C51.8125 54.2441 53.082 53.9805 54.0781 53.4531C55.0938 52.9062 55.8457 52.1641 56.334 51.2266C56.8418 50.2695 57.0957 49.166 57.0957 47.916C57.0957 46.6855 56.8711 45.6211 56.4219 44.7227C55.9727 43.8047 55.2891 43.1016 54.3711 42.6133C53.4727 42.1055 52.3203 41.8516 50.9141 41.8516C49.7812 41.8516 48.7363 42.0762 47.7793 42.5254C46.8418 42.9746 46.0898 43.6191 45.5234 44.459C44.9766 45.2793 44.7031 46.2656 44.7031 47.418H36.9395C36.9395 45.1133 37.5449 43.0918 38.7559 41.3535C39.9863 39.5957 41.6465 38.2188 43.7363 37.2227C45.8262 36.2266 48.1602 35.7285 50.7383 35.7285C53.5508 35.7285 56.0117 36.1973 58.1211 37.1348C60.25 38.0527 61.9004 39.4102 63.0723 41.207C64.2637 43.0039 64.8594 45.2305 64.8594 47.8867C64.8594 49.1562 64.5566 50.4258 63.9512 51.6953C63.3652 52.9453 62.4961 54.0781 61.3438 55.0938C60.2109 56.0898 58.8145 56.9004 57.1543 57.5254C55.5137 58.1309 53.6289 58.4336 51.5 58.4336H45.9043V54.2441ZM45.9043 60.2207V56.0898H51.5C53.9023 56.0898 55.9824 56.373 57.7402 56.9395C59.5176 57.4863 60.9824 58.2676 62.1348 59.2832C63.2871 60.2793 64.1367 61.4414 64.6836 62.7695C65.25 64.0977 65.5332 65.5234 65.5332 67.0469C65.5332 69.0391 65.1621 70.8164 64.4199 72.3789C63.6777 73.9219 62.6328 75.2305 61.2852 76.3047C59.957 77.3789 58.3945 78.1992 56.5977 78.7656C54.8008 79.3125 52.8574 79.5859 50.7676 79.5859C48.9512 79.5859 47.1836 79.3418 45.4648 78.8535C43.7656 78.3457 42.2324 77.5938 40.8652 76.5977C39.498 75.582 38.4141 74.3125 37.6133 72.7891C36.8125 71.2461 36.4121 69.459 36.4121 67.4277H44.1758C44.1758 68.5996 44.459 69.6445 45.0254 70.5625C45.6113 71.4805 46.4121 72.2031 47.4277 72.7305C48.4629 73.2383 49.625 73.4922 50.9141 73.4922C52.3398 73.4922 53.5605 73.2383 54.5762 72.7305C55.6113 72.2031 56.4023 71.4609 56.9492 70.5039C57.4961 69.5273 57.7695 68.3652 57.7695 67.0176C57.7695 65.416 57.4668 64.1172 56.8613 63.1211C56.2559 62.125 55.3867 61.3926 54.2539 60.9238C53.1406 60.4551 51.8125 60.2207 50.2695 60.2207H45.9043Z" fill="white" />
      </svg>
    </SvgIcon>
  );
}